/**
 * Maturity Credit factors — backed by the real
 * `GET /v2/credit-factors/claims-made` endpoint (orion-backend).
 *
 * Drives the Schedule's "Maturity Credit" dropdown. The backend returns
 * one row per maturity year with a `maturity_adjustment` fraction
 * (0.43 = 43% … 1.0 = 100%); the FE shows these as the selectable
 * percentages, defaulting to 100%.
 */
import { getJsonReal } from "../client";

export interface MaturityCreditFactor {
    year: number;
    /** 0–1 fraction, e.g. 0.43 = 43%. */
    maturityAdjustment: number;
}

interface MaturityCreditFactorWire {
    year: number;
    maturity_adjustment: number;
}

export function getMaturityCredits(): Promise<MaturityCreditFactor[]> {
    return getJsonReal<MaturityCreditFactorWire[]>("/v2/credit-factors/claims-made").then((rows) =>
        rows.map((r) => ({ year: r.year, maturityAdjustment: r.maturity_adjustment })),
    );
}
